import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import type { SimScenario } from '../simulator/scenarios';

export type DiagramSearchHit = {
  id: string;
  label: string;
  monitorKey: string;
};

export type DiagramChromeState = {
  diagramName: string;
  scenario: SimScenario;
  onScenario: (scenario: SimScenario) => void;
  query: string;
  onQueryChange: (query: string) => void;
  searchResults: DiagramSearchHit[];
  onPickSearch: (id: string) => void;
};

type DiagramChromeContextValue = {
  chrome: DiagramChromeState | null;
  setChrome: (next: DiagramChromeState | null) => void;
};

const DiagramChromeContext = createContext<DiagramChromeContextValue | null>(null);

export function DiagramChromeProvider({ children }: { children: ReactNode }) {
  const [chrome, setChromeState] = useState<DiagramChromeState | null>(null);
  const setChrome = useCallback((next: DiagramChromeState | null) => {
    setChromeState(next);
  }, []);
  const value = useMemo(() => ({ chrome, setChrome }), [chrome, setChrome]);
  return <DiagramChromeContext.Provider value={value}>{children}</DiagramChromeContext.Provider>;
}

export function useDiagramChrome() {
  return useContext(DiagramChromeContext);
}
